"use client";

import { useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import { CloseIcon } from "../assets/svgs";
import { getAppTheme } from "../utils/theme";

interface ButtonProps {
  label: any;
  onClick: () => void;
  //   className?: string;
  type?: any;
}

const Notification: React.FC<ButtonProps> = ({ label, onClick, type }) => {
  const [show, setShow] = useState(true);
  const textColor = type === "Success" ? "text-success" : "text-error";

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      onClick();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClick]);

  
  return (
    <>
      {/* <div
    
        className="pointer-events-none  inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
      > */}
      <div className="flex w-[70%] fixed top-3 right-5 flex-col items-center space-y-4 sm:items-end">
        {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
        <Transition show={show}>
          <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-bgCard shadow-lg ring-0 transition translate-y-2 transform duration-100 ease-in translate-x-2 sm:translate-y-0">
            <div className="p-4">
              <div className="flex items-start">
                <div className="shrink-0">
                  {/* <CheckCircleIcon aria-hidden="true" className="size-6 text-green-400" /> */}
                </div>
                <div className="ml-3 w-0 flex-1 pt-0.5">
                  <p
                    className={`${textColor} text-lg py-1 rounded `}
                  >
                    {type}
                  </p>
                  <p className=" text-sm text-text">{label}</p>
                </div>
                <div className="ml-4 flex shrink-0">
                  <button
                    type="button"
                    onClick={() => {
                      setShow(false);
                      onClick();
                    }}
                    className=" rounded-md"
                  >
                    <CloseIcon isActive={getAppTheme() === "dark"} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>
      {/* </div> */}
    </>
  );
};
export default Notification;
